import { el, type Nav, type Screen } from "./dom";
import { buildTopbar } from "./topbar";
import { i18n, t } from "../i18n";
import { chapters } from "../game/stages";
import { progress } from "../store/progress";
import { settings } from "../store/settings";
import type { Stage } from "../game/types";

function starRow(filled: number): string {
  let s = "";
  for (let i = 1; i <= 3; i++) s += `<span class="star ${i <= filled ? "on" : ""}">★</span>`;
  return s;
}

export class CampaignScreen implements Screen {
  private off?: () => void;
  constructor(private nav: Nav) {}

  private get cols(): number {
    return progress.effectiveCols(settings.get("boardCols"));
  }

  private isUnlocked(stage: Stage): boolean {
    return progress.isUnlocked(stage.id, stage.unlock?.requiresStage, this.cols);
  }

  mount(host: HTMLElement): void {
    const screen = el("div", "screen campaign");
    const top = buildTopbar({
      title: "menu.campaign",
      onBack: () => this.nav.home(),
      showStardust: true,
    });

    const widthBadge = el("div", "campaign-width-hint");
    const list = el("div", "stage-list");

    const render = (): void => {
      top.refresh();
      widthBadge.textContent = t("campaign.widthHint", { n: this.cols });
      list.innerHTML = "";
      for (const group of chapters()) {
        const header = el("div", "chapter-header");
        header.innerHTML = `<span>${t("campaign.world", { n: group.world })} · ${t(
          "campaign.chapter",
          { n: group.chapter },
        )}</span>`;
        list.appendChild(header);

        const grid = el("div", "stage-grid");
        for (const stage of group.stages) {
          const unlocked = this.isUnlocked(stage);
          const stars = progress.starsFor(stage.id, this.cols);
          const cell = el("button", `stage-cell ${unlocked ? "" : "locked"}`);
          cell.innerHTML = `
            <span class="stage-id">${stage.order}</span>
            ${unlocked ? `<span class="stage-stars">${starRow(stars)}</span>` : `<span class="lock">🔒</span>`}`;
          if (unlocked) cell.onclick = () => this.nav.play(stage.id);
          else cell.disabled = true;
          grid.appendChild(cell);
        }
        list.appendChild(grid);
      }
    };

    screen.append(top.node, widthBadge, list);
    host.appendChild(screen);
    render();
    this.off = i18n.onChange(render);
  }

  unmount(): void {
    this.off?.();
  }
}
